/**
 * t267u: whether a thread header needs its "N replies · Last reply …" summary. Once the thread is open and every reply
 * is already on screen, the count and last-reply time only repeat what is visible, so the header keeps just its
 * collapse chevron and "Open in sidebar" (inline), or a plain divider (phone thread). Collapsed, or with replies still
 * hidden behind "Show N more replies", the summary stays.
 */
export function showThreadSummary({ collapsed, shownCount, replyCount }: { collapsed: boolean; shownCount: number; replyCount: number }): boolean {
  if (collapsed) return true;
  return shownCount < replyCount;
}
